export default __webpack_public_path__ + "static/media/Harmonizing-Global-Skills-for-Industry-4-0.e3ebd4ef.mp4";